export default __webpack_public_path__ + "static/media/COK.935f952e.svg";